export function isMacPlatform(): boolean {
    if (typeof navigator === 'undefined') return false;
    const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
    const platform = nav.userAgentData?.platform ?? nav.platform ?? '';
    return /mac|iphone|ipad|ipod/i.test(platform);
}

/** Is this the shortcut that opens the palette: Cmd+K on a Mac, Ctrl+K elsewhere. */
export function isPaletteShortcut(event: KeyboardEvent, isMac: boolean = isMacPlatform()): boolean {
    const primaryModifier = isMac ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey;
    return primaryModifier && !event.altKey && !event.shiftKey && event.key.toLowerCase() === 'k';
}

